// src/business-types/saloon/modules/orders/SaloonOrderDisplay/components/OrderActions.tsx
import React from "react";
import { Box } from "@mui/material";
import CommonButtons from "src/shared/components/CommonButtons";
import { PERMISSIONS, useCheckPermission } from "src/permissionCheck/PermossionChick";
interface Props {
  order: any;
  onOpenPayment: () => void;
  onOpenCancel: () => void;
}

const OrderActions: React.FC<Props> = ({ order, onOpenPayment, onOpenCancel }) => {
  const { checkPermission } = useCheckPermission()
  const cancelOrder = checkPermission(PERMISSIONS.ORDER.CANCEL);

  if (order.OrderStatus === "Cancelled") return null;

  return (
    <Box display="flex" justifyContent="flex-end" gap={2} className="no-print mt-4">
      {cancelOrder && (
        <CommonButtons className="w-48" label="Cancel Order" variant="outlineDanger" onClick={onOpenCancel} disabled={order.OrderStatus !== "Confirm"} />
      )}

      {order.OrderStatus === "Confirm" ? (
        <CommonButtons className="w-52" label="Process Payment" onClick={onOpenPayment} />

      ) : (
        <CommonButtons className="w-52" label="Delivered" disabled />
      )}
    </Box>
  );
};

export default OrderActions;
